import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchModule, type FormatsEnvelope, type ModuleFilters } from '../api/events';

/**
 * Stable query key for the Events → Formats module envelope. Exported so
 * sibling code (e.g. an invalidator after an ingest) can refer to the
 * same key without re-deriving it.
 */
export function eventsFormatsKey(filters?: ModuleFilters) {
  return ['events', 'formats', filters ?? {}] as const;
}

/**
 * Fetch the Events → Formats envelope (array of format rows +
 * freshness/honesty metadata).
 *
 * Returns the full envelope so consumers can render `<Freshness/>`,
 * `<Denominator/>`, and `<AnomalyChip/>` alongside the chart.
 */
export function useEventsFormats(
  filters?: ModuleFilters,
): UseQueryResult<FormatsEnvelope, Error> {
  return useQuery({
    queryKey: eventsFormatsKey(filters),
    queryFn: ({ signal }) => fetchModule('formats', filters, { signal }),
    staleTime: 5 * 60 * 1000,
  });
}
